import React from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const JobFairDetail = () => {
  const { slug } = useParams();

  const fairs = {
    faridabad: {
      title: "Glimpses of Delhi NCR Job Fair – Faridabad",
      date: "4th October 2025",
      description:
        "The Job Fair held in Faridabad on 4th October 2025 was a great success. Hundreds of job seekers met top employers across multiple domains including IT, Sales, and Marketing. The event provided excellent networking opportunities for both recruiters and candidates.",
      images: [
        "/images/tatamotorsfaridabad.jpg",
        "/images/secondcomp.jpg",
        "/images/thirdcomp.jpg",
        "/images/fourthcomp.jpg",
         "/images/grp1.jpg",
        "/images/grp2.jpg",
      
      ],
    },
    faridabad2: {
      title: "Glimpses Delhi NCR Job Fair – Faridabad",
      date: " 08th November 2025",
      description:
 "Our Job Fair in Faridabad on 8th November 2025 was a huge success! It witnessed strong participation from job seekers and employers across multiple industries, including IT, Sales, and Marketing. ",      images: [
        // "/images/delhi1.jpg",
        // "/images/delhi2.jpg",
        // "/images/delhi3.jpg",
        // "/images/delhi4.jpg",
      ],
    },
     faridabad3: {
      title: "Glimpses of Delhi NCR Job Fair – Faridabad",
      date: " ",
      description:
        "",
      images: [
        // "/images/tatamotorsfaridabad.jpg",
        // "/images/secondcomp.jpg",
        // "/images/thirdcomp.jpg",
        // "/images/fourthcomp.jpg",
        //  "/images/grp1.jpg",
        // "/images/grp2.jpg",
      
      ],
    },
  };

  const fair = fairs[slug];

  if (!fair) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center">
          <h2 className="text-2xl font-semibold text-gray-600">
            Job Fair not found
          </h2>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 py-12">
        <h1 className="text-center text-3xl font-bold text-red-600 mb-4">
          {fair.title}
        </h1>
        <p className="text-center text-gray-500 mb-8">{fair.date}</p>
        <p className="text-gray-700 text-center max-w-3xl mx-auto mb-12">
          {fair.description}
        </p>




        {/* Image Gallery */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {fair.images.map((img, index) => (
            <div
              key={index}
              className="relative group overflow-hidden rounded-2xl shadow-md hover:shadow-lg transition-all duration-500"
            >
              <img
                src={img}
                alt={`${fair.title} ${index + 1}`}
                className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                <p className="text-white text-lg font-semibold">
                  {fair.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default JobFairDetail;
